// Dependencies
import React, { Component } from "react";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router-dom";

// Store
import { historyStore } from "../store/store";

// Components
import ActivityList from "./ActivityList/ActivityList.component";
import Footer from "../../home/components/Footer/footer.component";

// Styles
import "./HistoryPage.component.scss";

class HistoryPage extends Component {
    render() {
        return (
            <Provider store={historyStore}>
                <div id="HistoryPage">
                    <Switch>
                        <Route
                            path={"/history/activity"}
                            component={ActivityList}
                        />
                    </Switch>
                    <Footer />
                </div>
            </Provider>
        );
    }
}

export default HistoryPage;
